var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      ref: "cart",
      staticClass: "ci-card shadow-up",
      class: { show: _vm.show },
      attrs: { id: "comparison-list" },
    },
    [
      _c(
        "a",
        {
          staticClass:
            "comparison-list-toggle btn-cursor d-flex align-items-center font-weight-semi bg-primary text-white",
          on: { click: _vm.toggleShow },
        },
        [
          _c("div", { staticClass: "container-mw ci-content-padding-x" }, [
            _c("span", {
              staticClass: "pl-2 pr-3 mdi mdi-compare-horizontal mdi-24px",
            }),
            _c("span", {
              domProps: {
                textContent: _vm._s(
                  _vm.$t("ui.components.products.comparison_list.toggle", {
                    count: _vm.comparisonProducts.length,
                    max: 10,
                  })
                ),
              },
            }),
            _c("span", {
              staticClass: "pl-3 mdi mdi-chevron-up mdi-24px",
              class: { "mdi-rotate-180": _vm.show },
            }),
          ]),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "comparison-list-body container-mw ci-content-padding-x",
        },
        [
          _vm.comparisonProducts.length > 0
            ? [
                _c(
                  "div",
                  {
                    staticClass: "product-tiles-wrapper",
                    attrs: { id: "product-comparison-tiles" },
                  },
                  _vm._l(_vm.comparisonProducts, function (product, index) {
                    return _c("ci-comparison-list-tile", {
                      key: product.id,
                      attrs: {
                        product: product,
                        action: "remove",
                        id: `product-tile-${index + 1}`,
                      },
                    })
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "justify-content-end mt-4",
                    attrs: { id: "product-comparison-button" },
                  },
                  [
                    _c("ci-button", {
                      staticClass: "col-12 col-md-auto",
                      attrs: {
                        id: "start-comparison",
                        variant: "filled-primary",
                        disabled: _vm.comparisonProducts.length < 2,
                        target: "_blank",
                        label: _vm.$t(
                          "ui.components.products.comparison_list.start_comparison"
                        ),
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.startComparison.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]
            : [
                _c("span", {
                  attrs: { id: "empty-comparison-list" },
                  domProps: {
                    textContent: _vm._s(
                      _vm.$t("ui.components.products.comparison_list.empty")
                    ),
                  },
                }),
              ],
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }